module.exports = __webpack_public_path__ + "img/94.65e4954b.jpg";